import React, { useContext } from "react";
import { Switch, Route, Redirect } from "react-router";
import {
  withPermission,
  PermissionContext,
  Roles,
} from "../../../util/PermissionProvider";
import HomePage from "../HomePage";
import Layout from "../../Layout";
import MenuManagementPage from "../MenuManagementPage";
import MovieManagementPage from "../MovieManagementPage";
import NewsManagementPage from "../NewsManagementPage";
import OptionPage from "../OptionPage";
import PagesManagementPage from "../PagesManagementPage";
import PeriodManagementPage from "../PeriodManagementPage";
import PermissionManagementPage from "../PermissionManagementPage";
import ProfilePage from "../../ProfilePage";
import ProgrammesManagementPage from "../ProgrammesManagementPage";
import RemarksManagementPage from "../RemarksManagementPage";
import menu from "./menu";

export default function CineFanSection(props) {
  const { match } = props;
  const { userPermissions } = useContext(PermissionContext);
  console.log(match.url);
  return (
    userPermissions && (
      <Layout menuObj={menu}>
        <Switch>
          <Route
            path={`${match.url}/homepage`}
            component={withPermission(
              HomePage,
              [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
              [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
            )}
          />
          <Route path={`${match.url}/movies`} component={MovieManagementPage} />
          <Route path={`${match.url}/menu`} component={MenuManagementPage} />
          <Route
            path={`${match.url}/permission`}
            component={PermissionManagementPage}
          />
          <Route path={`${match.url}/news`} component={NewsManagementPage} />
          <Route path={`${match.url}/pages`} component={PagesManagementPage} />
          <Route
            path={`${match.url}/remarks`}
            component={RemarksManagementPage}
          />
          <Route
            path={`${match.url}/period`}
            component={PeriodManagementPage}
          />
          <Route
            path={`${match.url}/profile`}
            component={withPermission(ProfilePage, [
              Roles.SUPERADMIN,
              Roles.CINEFAN_EDITOR,
              Roles.CINEFAN_VIEWER,
            ])}
          />
          <Route
            path={`${match.url}/programmes`}
            component={ProgrammesManagementPage}
          />
          <Route
            path={`${match.url}/options`}
            component={withPermission(
              OptionPage,
              [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
              [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
            )}
          />
          <Route render={() => <Redirect to={`${match.url}/movies`} />} />
        </Switch>
      </Layout>
    )
  );
}
